import { IRootState } from '../../../store'
import { INeuroOptionsState } from '../store/options.types'

export const getNeuroOptionsSelector = (state: IRootState): INeuroOptionsState => state.options.neuroOptions
